module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/opony-5de04630.png";